(function() {
    'use strict';

    angular
        .module('atheer.core')
        .filter('tableImage', tableImage);

    tableImage.$inject = ['$sce', 'sanitizeHtml', '$window'];

    function tableImage($sce, sanitizeHtml, $window) {
        return filterFilter;

        /**
         * IE11 (and older environments): resolve href with a temporary anchor; same base as the
         * active document (matches URL(str, location.href) when the filter runs in the app window).
         */
        function canonicalHttpImageUrlViaAnchor(str) {
            var doc = $window.document;
            if (!doc || !angular.isFunction(doc.createElement)) {
                return null;
            }
            var a = doc.createElement('a');
            try {
                a.href = str;
            } catch (e) {
                return null;
            }
            var proto = (a.protocol || '').toLowerCase();
            if (proto !== 'http:' && proto !== 'https:') {
                return null;
            }
            var href = a.href;
            return href ? href : null;
        }

        /**
         * Resolve input to a canonical http(s) URL, or null if invalid / unsafe scheme.
         */
        function canonicalHttpImageUrl(value) {
            if (value === null || angular.isUndefined(value)) {
                return null;
            }
            var str = String(value).trim();
            if (str === '') {
                return null;
            }

            if ($window.URL) {
                try {
                    var base = ($window.location && $window.location.href) ?
                        $window.location.href :
                        'https://invalid.invalid/';
                    var parsed = new $window.URL(str, base);
                    var proto = (parsed.protocol || '').toLowerCase();
                    if (proto !== 'http:' && proto !== 'https:') {
                        return null;
                    }
                    return parsed.href;
                } catch (e) {
                    return null;
                }
            }

            return canonicalHttpImageUrlViaAnchor(str);
        }

        /**
         * Escape characters that could terminate or alter url('…') in an inline style.
         */
        function escapeForCssUrlSingleQuoted(href) {
            return href
                .replace(/\\/g, '%5C')
                .replace(/'/g, '%27')
                .replace(/"/g, '%22')
                .replace(/\(/g, '%28')
                .replace(/\)/g, '%29')
                .replace(/[\r\n\f]/g, '');
        }

        function filterFilter(value) {
            if (value === null || angular.isUndefined(value) || value === '') {
                return $sce.trustAsHtml('');
            }
            var canonical = canonicalHttpImageUrl(value);
            if (!canonical) {
                return $sce.trustAsHtml('');
            }
            var url = escapeForCssUrlSingleQuoted(canonical);
            var html = '<div style="background-image:url(\'' + url + '\')"></div>';

            return $sce.trustAsHtml(sanitizeHtml(html));
        }
    }

})();
